import { SustainabilityCardComponent } from '../../../components/common/sustainability-card/sustainability-card.component';
import { HeaderComponent } from '../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, SustainabilityCardComponent],
  selector: 'app-successfull-paperless-enrollment',
  templateUrl: './successfull-paperless-enrollment.component.html',
  styleUrls: ['./successfull-paperless-enrollment.component.scss']
})
export class SuccessfullPaperlessEnrollmentComponent {

}
